<template lang='pug'>
  v-flex(:class="classObj", :title='label')
    v-textarea.ma-0.pa-0(v-model='data', :label='label', :placeholder='component.placeholder', :readonly='component.readonly' :rows='component.rows', :required='component.required', :disabled='component.disabled', :suffix='component.suffix', :prefix='component.prefix || " "', hide-detail, @change="onChange")
</template>

<script>
export default {
  name: 'u-text-area',

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    value: {}
  },

  watch: {
    value (val) {
      this.data = val
    },
    data (val) {
      // this.$emit('input', val)
    }
  },

  computed: {
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  data () {
    return {
      data: null,
      result: {}
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/TextArea.vue